<template>
    <div class="search-input" :class="[{'gray': gray == ''}]">
        <template v-if="type == 'block'">
            <svg-icon v-if="gray == ''" class="icon" icon-class="search2"></svg-icon>
            <svg-icon v-else class="icon" icon-class="search0"></svg-icon>
        </template>
        <template v-else>
            <div class="icon" @click="toPage('/scan')"><svg-icon icon-class="scan"></svg-icon></div>
            <div class="line-vertical"></div>
        </template>
        <div class="input">
            <sd-input v-model="inputValue" :placeholder="placeholder" clear="2" disabled  @click.native="toPage('/search', {type: pageType})"></sd-input>
        </div>
        <div class="button" @click="toPage('/search', {type: pageType})">{{$t("text.search")}}</div>
    </div>
</template>

<script>
import sdInput from "./common/input.vue";

export default {
    name: "search-input",
    components: { sdInput },
    model: {
        prop: 'modelValue', // 默认是value
        event: 'modelInput', // 默认是input
    },
    props: {
        type: String,
        gray: String,
        modelValue: String || Number,
        clear: String,
        placeholder: String,
        pageType: String
    },
    data() {
        return {
            inputValue: this.modelValue,
        }
    },
    watch: {
        inputValue(val) {
            this.$emit("modelInput", val)
        },
        modelValue(val) {
            this.inputValue = val;
        }
    },
    methods: {
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        }
    }
}
</script>

<style scoped lang="scss">
    .search-input {
        // width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        border-radius: 18px;
        box-sizing: border-box;
        overflow: hidden;
        border: 1px solid rgba(226, 47, 37, 0.5);
        background: white;

        &.gray {
            background: #F1F3F6;
            border: none;
        }

        .icon {
            color: #e22f25;
            width: 30px;
            height: 30px;
            // background: gray;
            margin: 0 8px 0 12px;

            .scan {
                width: 100%;
                height: 100%;
            }

            &.search, &.search2 {
                width: 16px;
                height: 16px;
                margin-left: 10px;
                margin-right: -4px;
            }

            &.search0 {
                width: 17px;
                height: 17px;
                margin-left: 10px;
                margin-right: -5px;
                // width: 24px;
                // height: 24px;
                // margin-left: 6px;
                // margin-right: -8px;
            }
        }

        .input {
            flex: 1;
            margin: 0 12px;
            height: 100%;
            line-height: 100%;

            /deep/ .project-input {
                height: 100%;
                border: none;

                input {
                    background: transparent;
                    margin: 0;
                }

                .close {
                    margin-right: 0px;
                }
            }
        }

        .button {
            width: 76px;
            height: 30px;
            border-radius: 15px;
            margin-right: 3px;
            background: rgba(226, 47, 37, 1);

            font-size: 12px;
            line-height: 30px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/searchInput.vue